import { css } from 'emotion';
import { space } from '@joykit';
import { getInterUIDynamicMetricCssObject } from 'fonts/Inter-UI/metrics';

export namespace styles {
  export const container = css({
    width: 'auto',
    [`@media(min-width: 678px)`]: {
      width: 300
    }
  });
  export const frame = css({
    ...getInterUIDynamicMetricCssObject(15),
    ':not(:last-child)': {
      margin: space.stack.md
    }
  });
  export const button = css({
    width: '100%'
  });
  export const optionContainer = css({
    display: 'flex',
    width: '100%',
    justifyContent: 'space-between'
  });

  export const iconLabelWrapper = css({
    display: 'flex',
    alignItems: 'center',
    '> svg': {
      marginRight: 16,
      width: 30
    }
  });
}
